var map = {
	"./decidim/avatar-multiuser.png": 45843,
	"./decidim/brands/facebook.svg": 44667,
	"./decidim/brands/google.svg": 68434,
	"./decidim/brands/twitter-x.svg": 67475,
	"./decidim/cc-badge.png": 87185,
	"./decidim/decidim-logo.svg": 17025,
	"./decidim/default-avatar.svg": 69537,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 82455,
	"./decidim/icons.svg": 65376,
	"./decidim/pattern.png": 94435,
	"./decidim/placeholder-card-g.svg": 7136,
	"./decidim/placeholder-card-l.svg": 1643,
	"./decidim/placeholder.jpg": 46338,
	"./decidim/remixicon.symbol.svg": 21944,
	"./decidim/vendor/social-share-button/douban.svg": 43691,
	"./decidim/vendor/social-share-button/email.svg": 88420,
	"./decidim/vendor/social-share-button/facebook.svg": 43360,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 60980,
	"./decidim/vendor/social-share-button/hacker_news.svg": 48424,
	"./decidim/vendor/social-share-button/linkedin.svg": 25346,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 95224,
	"./decidim/vendor/social-share-button/pinterest.svg": 30562,
	"./decidim/vendor/social-share-button/reddit.svg": 59096,
	"./decidim/vendor/social-share-button/telegram.svg": 85965,
	"./decidim/vendor/social-share-button/tumblr.svg": 84010,
	"./decidim/vendor/social-share-button/twitter.svg": 90305,
	"./decidim/vendor/social-share-button/vkontakte.svg": 11115,
	"./decidim/vendor/social-share-button/wechat.svg": 48470,
	"./decidim/vendor/social-share-button/whatsapp.svg": 49870,
	"./decidim/vendor/social-share-button/x.svg": 7452,
	"./decidim/vendor/social-share-button/xing.svg": 13276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65350;